export class ContactFunctionalArea {
    Id: number;
    Name: string;
    ApplicationId: number;
    Status: number;
    CreatedBy: number;
    ModifiedBy: number;
}
